import { Component, EventEmitter, Input, OnInit, Output,  } from '@angular/core';
import { DadosPessoaisAba1Response } from 'app/auth/_models/DadosPessoaisAba1';
import { CampanhasService } from "../../service/campanhas/campanhas.service";
import { ParamentrosTextoCampanha } from "../../model/paramentrosTextoCampanha";

@Component({
  selector: 'app-orientacoes',
  templateUrl: './orientacoes.component.html',
  styleUrls: ['./orientacoes.component.sass']
})
export class OrientacoesComponent implements OnInit {
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();
  user: DadosPessoaisAba1Response = null;
  parametroDeTexto: ParamentrosTextoCampanha = null;
  constructor(private campanhasService: CampanhasService) {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));

  }

  ngOnInit(): void {
    this.findParametrosIniciais();
  }

  findParametrosIniciais(){
      this.campanhasService.getParamentrosDeTextoCampanha().subscribe(resp => {
        this.parametroDeTexto = resp;
      });
  };

  avancaParaProximoTab() {
    this.dadosSalvos.emit()

  }

  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }

}
